import { reduces } from '../reduce';
export const actions = {
    ...reduces.userInfoSlice.actions,
    ...reduces.aboutInfoSlice.actions,
    ...reduces.localesSlice.actions,
    ...reduces.scrollNumSlice.actions,
    ...reduces.newsDetailSlice.actions,
    ...reduces.jobDetailSlice.actions,
    ...reduces.recReSizeSlice.actions,
};